const PAYMENT_TYPE = {
	CASH: { code: "1", label: "common.typeList.paymentType.cash" },
	P2P: { code: "2", label: "common.typeList.paymentType.p2p" },
	BANK: { code: "3", label: "common.typeList.paymentType.bank" },
	CARD: { code: "4", label: "common.typeList.paymentType.card" },
	ACT: { code: "5", label: "common.typeList.paymentType.act" }
}

export default PAYMENT_TYPE
